const JobType = {

  Install: {},

  Service: {},

  Maintenance: {}

}

export default JobType



// WEBPACK FOOTER //
// ./src/reports/timeAllocation/JobType.js